import './contact-view-phone-layout.component.ajs.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './contact-view-phone-layout.component.ajs.html';

const MODULE_NAME = 'contactViewPhoneLayout';

class ContactViewPhoneLayoutCtrl implements IComponentController {
  public name = MODULE_NAME;

  constructor(private readonly $transcule: any) {}

  $onInit(): void {}

  hasTransclude(transcludeName: string) {
    return this.$transcule.isSlotFilled(transcludeName);
  }
}

export class ContactViewPhoneLayout implements IComponentOptions {
  templateUrl = templateUrl;
  transclude = {
    actionsRef: '?actionsRef',
    expandRef: '?expandRef',
    coreRef: '?coreRef',
  };
  bindings = {
    responseId: '<',
  };
  controller = ['$transclude', ContactViewPhoneLayoutCtrl];
}

export default MODULE_NAME;
